import * as React from "react";

import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { Container, Header, Loader, Segment } from "semantic-ui-react";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { flatten, uniq, values } from "lodash";

import { loadHrRepresentatives } from "@teamprevent/common/questionnaires/components/referralForm/actions";

import { GENERIC_CASE_QUESTIONNAIRE_KEY, GenericCaseForm } from "@teamprevent/common/genericCase/components/GenericCaseForm";

import { ApplicationState } from "../../applicationState";
import { selectAndMergeGenericCaseQuestionnaireConfig } from "../selectors";
import { loadGenericCaseConfig } from "../../questionnaireConfig/actions";

import { submitQuestionnaire as submitQuestionnaireAction } from "../actions";

import { push } from "redux-little-router";

export const WritableGenericCaseForm: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const questionnaireConfig = useSelector((state: ApplicationState) => selectAndMergeGenericCaseQuestionnaireConfig(state));
    const customerDetails = useSelector((state: ApplicationState) => state.customerDetails);
    const userFromState = useSelector((state: ApplicationState) => state.currentUser);
    const currentUser = React.useMemo(() => {
        return {
            name: userFromState.name,
            id: userFromState.id!,
            email: userFromState.email!,
            mobilePhone: userFromState.mobilePhone,
            roles: userFromState.roles
        };
    }, [userFromState]);

    const orgLevels = useSelector((state: ApplicationState) => state.referralForm.orgLevels);
    const hrRepresentatives = useSelector((state: ApplicationState) => state.referralForm.hrRepresentatives);
    const questions = useSelector((state: ApplicationState) => state.questionnaires[GENERIC_CASE_QUESTIONNAIRE_KEY] ?
        uniq(flatten(state.questionnaires[GENERIC_CASE_QUESTIONNAIRE_KEY].sections.map(section => values(section.questions)))) :
        []);

    React.useEffect(() => {
        dispatch(loadGenericCaseConfig());
        dispatch(loadHrRepresentatives());
    }, [dispatch]);

    const returnToHomePage = React.useCallback(() => dispatch(push("/", { })), [dispatch]);

    const submitQuestionnaire = React.useCallback(async (answers: AnsweredQuestionWithId[]): Promise<boolean> => {
        await dispatch(submitQuestionnaireAction(answers, GENERIC_CASE_QUESTIONNAIRE_KEY));
        if (answers.every(a => a.isValid)) {
            returnToHomePage();
            return false;
        }

        return true;
    }, [dispatch, returnToHomePage]);

    if (questionnaireConfig && customerDetails && currentUser) {

        return (
            <Container className="generic-case-form">
                <Container>
                    <Segment basic>
                        <Header as="h1">Request Other Services</Header>
                    </Segment>
                </Container>
                <GenericCaseForm
                    readonly={false}
                    genericCaseTypes={customerDetails.genericCaseTypes}
                    currentUser={currentUser}
                    orgLevels={orgLevels}
                    hrRepresentatives={hrRepresentatives}
                    questionnaireConfig={questionnaireConfig}
                    questions={questions}
                    submitQuestionnaire={submitQuestionnaire}
                />
            </Container>
        );
    }

    return <Loader active />;
};
